import { ILocalizedString } from '../../../interfaces/LocalizedString.interface';
import { CONFIG } from '../config/config.const';

export function getLocalizedText(searchInput: ILocalizedString[], cultureCode: string) {
    let localizedString = searchInput.find(locString => locString.cultureCode === cultureCode);
    if (localizedString) {
        return localizedString.text;
    } else {
        localizedString = searchInput.find(locString => locString.cultureCode === CONFIG.DEFAULT_LOCALE);
        if (localizedString) {
            return localizedString.text;
        }
    }
    return searchInput[0].text;
}
